import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { fa } from "typed-font-awesome";
type Entity = models.PaquetePPDto;
const fixCols: kea.Grid2Column<Entity>[] = [
    {
        title: "Folio",
        cell: x => ({ data: x.Folio })
    }, {
        title: "Cancelado",
        cell: x => ({ data: x.Cancelado ? "Si" : "No"  })
    }, {
        title: "Fecha",
        cell: x => ({ data: kea.toDate(x.FechaCreacion) })
    }, {
        title: "Cliente",
        cell: x => ({ data: x.NombreCliente })
    }, {
        title: "Cant. guías",
        cell: x => ({ data: x.CantGuiasTotal })
    }, {
        title: "Cant. guías restantes",
        cell: x => ({ data: x.CantGuiasTotal - x.CantGuiasGastadas })
    }, {
        title: "Cant. guías gastadas",
        cell: x => ({ data: x.CantGuiasGastadas })
    }, {
        title: "Tarifa",
        cell: x => ({ data: x.NombreTarifaPP })
    }, {
        title: "Total",
        cell: x => ({ data: x.ImporteTotal, view: kea.formatCurrency })
    }, {
        title: "Descuento",
        cell: x => ({ data: x.Descuento, view: kea.formatPercent })
    }, {
        title: "Factura",
        cell: x => ({ data: x.FolioFactura })
    }, {
        title: "Factura Pagada",
        cell: x => ({ data: x.FacturaContadoPagada ? "Pagada" : "Sin Pagar" })
    }, {
        title: "Tipo Pago",
        cell: x => ({ data: x.TipoPagoFactura == 0 ? "Contado" : "Credito" })
    }, {
        title: "Cli. orig.",
        cell: x => ({ data: x.NombreClienteOrigen })
    }, {
        title: "Cli. dest.",
        cell: x => ({ data: x.NombreClienteDestino })
    }, {
        title: "Apli. paq.",
        cell: x => ({ data: x.AplicaPaquete })
    }, {
        title: "Apli. sob.",
        cell: x => ({ data: x.AplicaSobre })
    }, {
        title: "Sucursal",
        cell: x => ({ data: x.NombreSucursal })
    }
];

type ButtonAction = (x: Entity) => void;

interface Deps {
    onVer: ButtonAction;
    onFacturar: ButtonAction;
    onFacturarTimbrar: ButtonAction;
    onImprimir: ButtonAction;
    onCancelarGuias: ButtonAction;
    onCancelarPaquetePP: ButtonAction;
    PagarPaquetePP: ButtonAction;
    MostrarBotonPagarPAquete: (x: Entity) => boolean;

}

export function getColumnas(deps: Deps): kea.Grid2Column<Entity>[] {
    const botones =
        kea.columnaBotones([
        {
            iconClass: fa("eye"),
            onClick: deps.onVer,
            tooltip: "Ver"
        }, {
            iconClass: fa("credit-card"),
            onClick: deps.onFacturar,
            tooltip: "Facturar"
        }, {
            iconClass: fa("bell"),
            onClick: deps.onFacturarTimbrar,
            tooltip: "Facturar y timbrar"
        }, {
            iconClass: fa("print"),
            onClick: deps.onImprimir,
            tooltip: "Imprimir"
        }, {
            iconClass: fa("times-circle-o"),
            onClick: deps.onCancelarGuias,
            tooltip: "Cancelar guias"
        },{
            iconClass: fa("money"),
            onClick: deps.PagarPaquetePP,
            tooltip: "Marcar paquete pagado",
            disabled: x => deps.MostrarBotonPagarPAquete(x)

        }, {
            iconClass: fa("times-circle"),
            onClick: deps.onCancelarPaquetePP,
            tooltip: "Cancelar PaquetePP"
        }
    ])   ;

    const cols = [botones, ...fixCols];
    return cols;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/list/columns.tsx